import { UAParser } from 'ua-parser-js';

const DEVICE_ID_KEY = 'deviceId';

export const getDeviceId = () => {
  const deviceId = localStorage.getItem(DEVICE_ID_KEY) || '';
  if (deviceId) {
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
    return deviceId;
  }

  return deviceId;
};

export const setDeviceId = (deviceId: string) => {
  localStorage.setItem(DEVICE_ID_KEY, deviceId);
};

export const removeDeviceId = () => {
  localStorage.removeItem(DEVICE_ID_KEY);
};

export const getDeviceName = () => {
  const parser = new UAParser();
  const result = parser.getResult();

  const browser = result.browser.name || 'Unknown Browser';
  const deviceType = result.device.type ? result.device.type : 'Desktop';
  const os = result.os.name || '';

  return `${browser} / ${deviceType === 'mobile' ? os : deviceType}`;
};
